//SelectEventCategoryDialog
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { Dialog, IDialogButton } from "./dialog";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { IIdCodeDivider } from "source/models/common/idCodeDivider";

//IdCodeListLine
export interface IIdCodeListLineProp {
    item: IIdCodeDivider;
    selected: boolean;
    onClick: (id: string) => void;
}

export class IdCodeListLine extends React.Component<IIdCodeListLineProp, {}> {
    handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick(this.props.item.id);
    };

    render() {
        const item = this.props.item;
        return (
            <div className={"line" + (this.props.selected ? " selected" : "") + (this.props.onClick ? "" : " title")} onClick={this.props.onClick ? this.handleClick : null}>
                <div className="row">
                    <div className={"col col-12"}>
                        <div className="singleLine">{item.code}</div>
                    </div>
                </div>
            </div>
        );
    }
}

//SelectEventTypeDialog
export interface ISelectIdCodeDialogProps {
    classes?: string;
    nextPreviousMode?: boolean;
    title: string;
    selectedId: string;
    loadIdCodes: (page: number) => Promise<IEndlessList<IIdCodeDivider>>;
    showOkButton?: boolean;
    okButtonTitle?: string;
    onOk: (id: string, code: string) => void;
    onCancel: () => void;
    onPrevious?: () => void;
}

export interface ISelectIdCodeDialogState {
    idCodes: IIdCodeDivider[];
    page: number;
    hasMore: boolean;
    isLoading: boolean;
    selectedId: string;
    setSelectedId: boolean;
}

export class SelectIdCodeDialog extends React.Component<ISelectIdCodeDialogProps, ISelectIdCodeDialogState> {
    private containerDiv: HTMLDivElement;
    private listDiv: HTMLDivElement;

    constructor(props) {
        super(props);
        this.state = { idCodes: [], selectedId: props.selectedId, page: 1, isLoading: false, hasMore: true, setSelectedId: Base.isNullOrEmpty(props.selectedId) };
    }

    loadIdCodes = (page: number) => {
        const obj = this;
        this.props.loadIdCodes(page).then(userList => {
            if (Base.isNullOrUndefined(userList)) return;
            const oldIds = {};
            for (let j = 0; j < obj.state.idCodes.length; j++) {
                oldIds[obj.state.idCodes[j].id] = true;
            }
            const newItems = userList.items.filter(i => Object.prototype.hasOwnProperty.call(oldIds, i.id) ? false : (oldIds[i.id] = true));
            const idCodes = [...obj.state.idCodes, ...newItems];
            let selectedId = obj.state.selectedId;
            if (obj.state.setSelectedId && idCodes.length > 0 && !Base.isNullOrUndefined(idCodes[0])) {
                selectedId = idCodes[0].id;
            }
            obj.setState({ idCodes: [...obj.state.idCodes, ...newItems], page: userList.page, hasMore: userList.hasMore, selectedId });
        });
    };
        
    handleScrollSub = Base.debounce((obj: SelectIdCodeDialog) => {
        if (obj.state.isLoading || !obj.state.hasMore) return;
        if (obj.listDiv.offsetHeight - (obj.containerDiv.clientHeight + obj.containerDiv.scrollTop) < 5) {
            obj.loadIdCodes(obj.state.page + 1);
        }
    }, 100);

    handleScroll = (event) => {
        this.handleScrollSub(this);
    };

    handleLineClick = (id: string) => {
        if (Base.isNullOrEmpty(id)) return;
        const idCode = this.state.idCodes.find(i => i.id === id);
        if (Base.isNullOrUndefined(idCode)) return;
        this.setState({
            selectedId: id
        });
        if (this.props.showOkButton) return;
        this.props.onOk(idCode.id, idCode.code);
    };

    componentDidMount(): void {
        this.containerDiv.addEventListener("scroll", this.handleScroll);
        this.loadIdCodes(1);
    }

    componentWillUnmount(): void {
        this.containerDiv.removeEventListener("scroll", this.handleScroll);
    }

    handleOkClick = () => {
        const selectedId = this.state.selectedId;
        const idCode = this.state.idCodes.find(i => i.id === selectedId);
        if (Base.isNullOrUndefined(idCode)) {
            this.props.onOk("", "");
        } else {
            this.props.onOk(idCode.id, idCode.code);
        }
    };

    render() {
        const props = this.props;
        const buttons: IDialogButton[] = [];
        if (props.nextPreviousMode) {
            if (props.onPrevious) {
                buttons.push({ title: Translations.Previous, buttonType: DialogButtonType.Default, onClick: props.onPrevious });
            }
            if (props.onOk) {
                buttons.push({ title: Translations.Next, buttonType: DialogButtonType.Default, onClick: this.handleOkClick });
            }
        } else {
            if (props.showOkButton) {
                buttons.push({ title: props.okButtonTitle ?? Translations.OK, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick });
            }
            buttons.push({ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: props.onCancel });
        }
        const dialogClasses = "selectIdCodeDialog" + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={props.title}
                body={
                    <div className="largeDialogContent" ref={(elem) => { this.containerDiv = elem; }}>
                        <div className="lineContainer" ref={(elem) => { this.listDiv = elem; }}>
                            {this.state.idCodes.map(item => (
                                <IdCodeListLine
                                    key={item.id}
                                    item={item}
                                    selected={this.state.selectedId === item.id}
                                    onClick={item.divider ? null : this.handleLineClick}
                                />
                            ))}
                        </div>
                    </div>
                }
                buttons={buttons}
                onClose={props.onCancel}/>
        );
    }
}